import auth from './auth'
import checkUserLevel from './checkUserLevel'
import setPageTitle from './setPageTitle'
import setView from './setView'

export function setMiddlewares(to, from, next) {
    auth(to, from, next)
    checkUserLevel(to, from, next)
    setView(to, from, next)
    setPageTitle(to, from, next)
}
